import robRolePermissions from 'constants/robRolePermissions'
import { userRoleSelector } from 'domain/User/selectors'
import { useSelector } from 'react-redux'

/**
 * Returns a `can` function that checks whether the logged-in user
 * has a given ROB permission based on their role.
 *
 * Usage:
 *   const can = usePermission()
 *   can(robPermissions.EDIT_SEALS)  // → true | false
 */
const usePermission = () => {
  // TODO: remove hardcoded role once backend is ready
  // const role = 'surveyor'
  const role = useSelector(userRoleSelector)
  const permissions = robRolePermissions[role] ?? []

  return permission => permissions.includes(permission)
}

export default usePermission
